import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function MarketPlacePolicyBasicInfoComponent ({organizationUnits,entityTypes,onFormChange, selectedProgram}: any) {
  const entityType: any = [
    { Description: 'Products', Value: 3 },
    { Description: 'Vendors', Value: 41 },
  ]
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer

label="Active"
name="IsActive"
onValueChange={(event: any) => {
  onFormChange({
    value: event,
    field: 'IsActive'
  });
}}
type="checkbox"
value={selectedProgram?.IsActive}
/>

<InputContainer

label="Name"
name="Name"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Name'
  });
}}
type="text"
value={selectedProgram?.Name}
/>
 
<InputContainer

label="Display Order"
name="DisplayOrder"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'DisplayOrder'
  });
}}
type="number"
value={selectedProgram?.DisplayOrder}
/>

    <InputContainer

    label="Market Place Type"
    labelField="Description"
    list={entityType}
    onValueChange={(event: any) => {
      onFormChange({
        value: event.target.value,
        field: 'MarketplaceTypeId'
      });
    }}
    optionName='Choose OrderType'
    type="select"
    value={selectedProgram?.MarketplaceTypeId}
    valueField="Value"
    />

<InputContainer
    label="Limited To OrganizationUnit" 
     labelField="OrganizationUnitInfo.Name"
     list={organizationUnits}
     onValueChange={( newValue: any) => {
         const valueData: any = newValue.map((option: any) => option?.value || '')

         onFormChange({
          value: valueData,
            field: 'LimitedToOrganizationUnitIds',
     });
       }}
       type="multiselect"
       valueField="OrganizationUnitInfo.Id"
       value={selectedProgram?.LimitedToOrganizationUnitIds}
   />
<InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Remarks'
  });
}}
type="text"
value={selectedProgram?.Remarks}
/>



                <InputContainer

                label="Start Date"
                name="StartDateUtc"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'StartDateUtc'
                  });
                } }
                type="date"
                value={selectedProgram?.StartDateUtc} /><InputContainer

                  label="End Date"
                  name="EndDateUtc"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'EndDateUtc'
                    });
                  } }
                  type="date"
                  value={selectedProgram?.EndDateUtc} />
              
<InputContainer

label="Description"
name="Description"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Description'
  });
}}
type="text"
value={selectedProgram?.Description}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}